import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-inline flex-nowrap bg-light mx-0 mx-lg-auto rounded p-1" }
const _hoisted_2 = { class: "input-group rounded" }
const _hoisted_3 = ["disabled", "placeholder"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text border-0",
  id: "search-addon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListComponent = _resolveComponent("ListComponent")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        disabled: (_ctx.$store.state.requiresAuth === 3),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
        class: "form-control me-2 rounded",
        onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.myChild.Init()), ["prevent"]), ["enter"])),
        type: "search",
        placeholder: _ctx.placeholder,
        "aria-label": "Search"
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.title]
      ]),
      _createElementVNode("button", {
        disabled: (_ctx.$store.state.requiresAuth === 3),
        type: "button",
        class: "btn",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {_ctx.$refs.myChild.Init();}, ["prevent"]))
      }, _hoisted_6, 8, _hoisted_4)
    ]),
    (_ctx.title !== '')
      ? (_openBlock(), _createBlock(_component_ListComponent, {
          key: 0,
          title: _ctx.title,
          ref: "myChild"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}